import React from 'react';
import OnboardingStep from './OnboardingStep';

const OnboardingMainScreen = () => {
    return (
        <OnboardingStep />
    )
};

export default OnboardingMainScreen;